import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import { useAlert, types } from 'react-alert';
import { useHistory } from 'react-router-dom';
import { PageTitle, PaperWithTitle, PagingTable, ConfirmDialog } from '../../../components';
import { useClinicUser, useMaster, useModificationRequest } from '../../../../model/hooks';
import { getLabelFromString, getLabelModifiedAmount, getLabelReward } from '../../../common/helper';
import { Utils } from '../../../../common/helper';
export const ModificationList = () => {
    var _a, _b;
    const { t } = useTranslation();
    const { master } = useMaster();
    const { paymentClinic } = useClinicUser();
    const reactAlert = useAlert();
    const history = useHistory();
    const { columns, loadModificationList, approvalCorrectReward, loading, loadingApproval } = useModificationRequest();
    const [rows, setRows] = useState([]);
    const [targetRow, setTargetRow] = useState(null);
    const [isOpenApproveDialog, setIsOpenApproveDialog] = useState(false);
    const [isOpenDenialDialog, setIsOpenDenialDialog] = useState(false);
    const loadListData = async (lastDocument) => {
        const result = await loadModificationList(lastDocument);
        return result.data.map((item) => {
            var _a, _b, _c;
            return {
                id: item.id,
                content: getLabelFromString(item.title),
                worker: `${item.workerLastName} ${item.workerFirstName}`,
                reward: getLabelReward((_a = master) === null || _a === void 0 ? void 0 : _a.rewardTypeList, item.rewardTypeId, item.rewardAmount),
                jobOfferId: (_b = item.jobOfferId, (_b !== null && _b !== void 0 ? _b : '')),
                isApprove: (_c = item.isApprove, (_c !== null && _c !== void 0 ? _c : null)),
                modifiedAmount: item.modifiedAmount,
                detail: item,
            };
        });
    };
    const onMore = async () => {
        if (rows.length > 0) {
            const lastRow = rows.slice(-1)[0];
            const _rows = await loadListData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setRows(rows.concat(_rows));
            }
        }
    };
    const onClickContent = (id) => {
        var _a;
        const selectedRow = rows.find((item) => item.id === id);
        history.push(`/home/job_offer/detail/${(_a = selectedRow) === null || _a === void 0 ? void 0 : _a.jobOfferId}`);
    };
    const approvalDenial = async (modificationRequestId, isApprove, amount) => {
        try {
            await approvalCorrectReward(modificationRequestId, isApprove, amount);
            const message = isApprove ? t('承認しました') : t('否認しました');
            reactAlert.show(message, { type: types.SUCCESS });
            setTargetRow(null);
            setIsOpenApproveDialog(false);
        }
        catch (e) {
            if (e instanceof Error)
                reactAlert.show(e.message, { type: types.ERROR });
        }
    };
    const onClickApproveButton = useCallback((id) => {
        const row = rows.find((item) => item.id === id);
        setTargetRow(row);
        setIsOpenApproveDialog(true);
    }, [rows]);
    const onClickDenialButton = useCallback((id) => {
        const row = rows.find((item) => item.id === id);
        setTargetRow(row);
        setIsOpenDenialDialog(true);
    }, [rows]);
    const onClickApprove = useCallback(() => {
        if (!targetRow)
            return;
        approvalDenial(targetRow.id, true, targetRow.modifiedAmount);
    }, [targetRow]);
    const onClickDenial = useCallback(() => {
        if (!targetRow)
            return;
        approvalDenial(targetRow.id, false, targetRow.modifiedAmount);
    }, [targetRow]);
    const onCloseApproveDialog = useCallback(() => setIsOpenApproveDialog(false), []);
    const onCloseDenialDialog = useCallback(() => setIsOpenDenialDialog(false), []);
    useEffect(() => {
        const f = async () => {
            try {
                const _rows = await loadListData();
                setRows(_rows);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        if (Utils.isNotNull(paymentClinic) && Utils.isNotNull(master)) {
            f();
        }
    }, [paymentClinic, master]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('修正依頼一覧')),
        React.createElement(SGrid, { container: true },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(PaperWithTitle, { title: "\u4FEE\u6B63\u4F9D\u983C\u4E00\u89A7" },
                    React.createElement(PagingTable, { columns: columns, rows: rows, loading: loading, onClickContent: onClickContent, onClickExpandMore: onMore, onClickApproveButton: onClickApproveButton, onClickDenialButton: onClickDenialButton })))),
        React.createElement(ConfirmDialog, { isOpen: isOpenApproveDialog, title: "", negativeLabel: t('キャンセル'), positiveLabel: t('承認する'), isCancel: true, onClose: onCloseApproveDialog, onClickNegative: onCloseApproveDialog, onClickPositive: onClickApprove, loading: loadingApproval },
            React.createElement("div", null,
                React.createElement(SModalTitle, null, t('以下の追加報酬金額の支払いを承認しますか？')),
                React.createElement(SModalTitle, null, t('承認するとワーカーへの支払いが実行されます。')),
                React.createElement(SModalContent, null, `${t('追加報酬金額')}： ${getLabelModifiedAmount((_a = targetRow) === null || _a === void 0 ? void 0 : _a.modifiedAmount)}円`))),
        React.createElement(ConfirmDialog, { isOpen: isOpenDenialDialog, title: "", negativeLabel: t('キャンセル'), positiveLabel: t('否認する'), isCancel: true, isNegative: true, onClose: onCloseDenialDialog, onClickNegative: onCloseDenialDialog, onClickPositive: onClickDenial, loading: loadingApproval },
            React.createElement("div", null,
                React.createElement(SModalTitle, null, t('以下の追加報酬の支払いを否認しますか？')),
                React.createElement(SModalContent, null, `${t('追加報酬金額')}： ${getLabelModifiedAmount((_b = targetRow) === null || _b === void 0 ? void 0 : _b.modifiedAmount)}円`)))));
};
const SGrid = styled(Grid) `
  padding-top: 32px;
  padding-bottom: 32px;
`;
const SModalTitle = styled.p `
  font-weight: bold;
  margin-bottom: 8px;
  text-align: center;
`;
const SModalContent = styled.p `
  margin-top: 32px;
  text-align: center;
`;
